import { z } from 'zod';

/**
 * Support Request form schema.
 * Used for validation in ContactEditPage.
 */
export const supportRequestSchema = z.object({
  title: z.string().min(1, 'タイトルは必須です。'),
  body: z.string().min(1, '本文は必須です。'),
  name: z.string().max(255, '名前は255文字以下にしてください。').optional().or(z.literal('')),
  re_email: z
    .string()
    .min(1, '返信メールアドレスは必須です。')
    .email('返信メールアドレスを正しいメールアドレスにしてください。')
    .max(255, '返信メールアドレスは255文字以下にしてください。'),
});

export type SupportRequestFormData = z.infer<typeof supportRequestSchema>;
